const nlContact = {
  seo: {
    title: "Contact | Ramen Repair Eindhoven — Bel 040 798 7470",
    description: "Neem contact op met Ramen Repair Eindhoven voor kozijn-, raam- en schuifpuireparatie. Telefoon 040 798 7470, 7 dagen per week bereikbaar.",
  },
  breadcrumb: {
    home: "Home",
    current: "Contact",
  },
  hero: {
    pill: "CONTACT",
    h1: "Neem contact op",
    subhead: "Wij staan 7 dagen per week voor u klaar. Bel direct of vul het formulier in — wij reageren binnen enkele uren met een eerlijke offerte.",
    ctaPhone: "Bel direct",
    ctaEmail: "Stuur e-mail",
  },
  cards: {
    h2: "Hoe wilt u ons bereiken?",
    card1: {
      label: "TELEFOON",
      value: "040 798 7470",
      tel: "+31407987470",
      note: "Maandag t/m zondag, 08:00 - 20:00. Voor spoedreparaties ook 's nachts bereikbaar.",
    },
    card2: {
      label: "E-MAIL",
      value: "info@ramen-repair-eindhoven.nl",
      mailto: "info@ramen-repair-eindhoven.nl",
      note: "Wij reageren binnen enkele uren, ook in het weekend. Voor offerteaanvragen graag een foto bijvoegen.",
    },
    card3: {
      label: "SERVICEGEBIED",
      value: "Eindhoven en omstreken",
      note: "Wij komen ter plaatse in Eindhoven, Veldhoven, Geldrop, Nuenen, Helmond, Best, Waalre en Son en Breugel.",
    },
  },
  hours: {
    h2: "Wanneer zijn wij bereikbaar?",
    p1: "Onze telefonische bereikbaarheid is ruim, want wij weten dat een kapot raam of vastgelopen schuifpui zich niet aan kantooruren houdt.",
    rows: [
      { day: "Maandag t/m vrijdag", time: "08:00 - 20:00" },
      { day: "Zaterdag", time: "08:00 - 20:00" },
      { day: "Zondag", time: "08:00 - 20:00" },
      { day: "Spoedservice (inbraak, gebroken ruit)", time: "24 uur per dag" },
    ],
    note: "Voor reguliere afspraken werken wij met een termijn van 48 tot 72 uur. Spoedreparaties vaak binnen 2 uur ter plaatse.",
  },
  form: {
    h2: "Stuur ons een bericht",
    intro: "Vertel ons kort wat er aan de hand is — wij nemen binnen enkele uren contact met u op met een eerlijk advies en, indien gewenst, een vrijblijvende offerte.",
    stepLabels: ["Probleem", "Materiaal", "Persoonsgegevens"],
    step1: {
      label: "Waar heeft u last van?",
      options: [
        "Raam sluit niet",
        "Schuifpui loopt stroef",
        "Beslag of kruk defect",
        "Glas vervangen",
        "Inbraakschade",
        "Velux dakraam",
        "Slot vervanging",
        "Anders / weet ik niet",
      ],
    },
    step2: {
      label: "Welk materiaal is uw kozijn?",
      options: ["PVC", "Aluminium", "Hout", "Weet niet"],
    },
    step3: {
      firstName: "Voornaam",
      lastName: "Achternaam",
      phone: "Telefoonnummer",
      email: "E-mailadres",
      postcode: "Postcode (4 cijfers)",
      wijk: "Wijk (optioneel)",
      message: "Bericht",
      gdpr: "Ik ga akkoord met het privacybeleid",
      submit: "Bericht versturen",
      back: "Terug",
      next: "Volgende",
    },
    success: {
      title: "Bedankt!",
      desc: "Wij hebben uw bericht ontvangen en nemen binnen 24 uur contact met u op.",
    },
  },
  wijken: {
    h2: "Wij komen overal in Eindhoven",
    leftLabel: "Wijken in Eindhoven",
    leftTags: [
      "Centrum", "Strijp-S", "Strijp-T", "Philipsdorp",
      "Woensel-Noord", "Woensel-Zuid", "Stratum", "Geestenberg",
      "Gestel", "Hanevoet", "Tongelre", "Lakerlopen", "'t Hofke",
    ],
    rightLabel: "Omliggende gemeenten",
    rightTags: [
      "Veldhoven", "Geldrop", "Nuenen", "Helmond",
      "Best", "Waalre", "Son en Breugel", "Mierlo",
      "Eersel", "Valkenswaard",
    ],
  },
  faq: {
    h2: "Vaak gestelde vragen",
    items: [
      { q: "Hoe snel reageren jullie op een offerteaanvraag?", a: "Binnen enkele uren, vaak nog dezelfde dag, 7 dagen per week." },
      { q: "Kunnen jullie 's avonds of op zondag komen?", a: "Voor spoedreparaties ja, regulier op werkdagen en zaterdag." },
      { q: "Wat kost een eerste bezoek?", a: "De diagnose en offerte ter plaatse zijn altijd gratis in Eindhoven en omstreken." },
      { q: "Welke betaalmethoden accepteren jullie?", a: "Pin, contant of overschrijving. Zakelijke klanten op factuur." },
      { q: "Hoe ver werken jullie buiten Eindhoven?", a: "Standaard binnen 25 km, daarbuiten op aanvraag met kleine voorrijtoeslag." },
    ],
  },
  ctaBanner: {
    h2: "Liever direct contact?",
    cta: "Bel 040 798 7470",
  },
};

export default nlContact;